import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLocationDot,
  faPhone,
  faEnvelope,
} from '@fortawesome/free-solid-svg-icons';
import {
  faFacebook,
  faLinkedin,
  faInstagram,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import logoImage from '../images/NH medical-logo_Mian-02.png';

const Footer = () => {
  return (
    <footer className="bg-dark py-5">
      <div className="container">
        <div className="row justify-content-between align-items-start">
          
          {/* <div className="col-md-4 d-flex justify-content-start">
            <img
              src={logoImage}
              alt="NH Icon"
              className="img-fluid"
              style={{ maxWidth: '145px', height: 'auto' }}
            />
          </div> */}

          <div className="col-md-4 text-white">
            <h5 className="mb-3">Contact</h5>
            <div className="d-flex align-items-center mb-2">
              <FontAwesomeIcon icon={faLocationDot} className="me-2" />
              <div>
                225 Hung Vuong Street, Ward 9, District 5, <br />
                HCM City, VietNam
              </div>
            </div>
            <div className="d-flex align-items-center mb-2">
              <FontAwesomeIcon icon={faPhone} className="me-2" />
              +84 941 144 333
            </div>
            <div className="d-flex align-items-center">
              <FontAwesomeIcon icon={faEnvelope} className="me-2" />
              nguyenhoang@nhmed.com.vn
            </div>
          </div>

          <div className="col-md-4 text-white">
            <h5 className="mb-3">Social Media</h5>
            <div className="d-flex gap-3">
              <a href="#" className="text-white">
                <FontAwesomeIcon icon={faFacebook} size="lg" />
              </a>
              <a href="#" className="text-white">
                <FontAwesomeIcon icon={faLinkedin} size="lg" />
              </a>
              <a href="#" className="text-white">
                <FontAwesomeIcon icon={faInstagram} size="lg" />
              </a>
              <a href="#" className="text-white">
                <FontAwesomeIcon icon={faYoutube} size="lg" />
              </a>
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;